import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconEnvelope12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconEnvelope12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10.5 2h-9a.5.5 0 0 0-.133.018l4.64 4.639 4.635-4.636A.5.5 0 0 0 10.5 2M1 8.763V3.065l2.849 2.849zm.246 1.168q.113.068.254.069h9a.5.5 0 0 0 .26-.073L7.457 6.622 6.36 7.718l-.354.353-.353-.353L4.556 6.62zm6.917-4.016L11 8.752V3.077zM1.5 1A1.5 1.5 0 0 0 0 2.5v7A1.5 1.5 0 0 0 1.5 11h9A1.5 1.5 0 0 0 12 9.5v-7A1.5 1.5 0 0 0 10.5 1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconEnvelope12);
